import API from "./api";
import { OpenInNewModalSVG } from "./icons";
import { ShowProposalSubmitting, ShowProposalSuccess } from "./snackbar";
import OpenDialog from "./dialog";
import OpenErrorDialog from "./dialog_error";

export default class extends HTMLElement {
    #button = null;
    #originalTitle = ""

    connectedCallback () {
        this.#originalTitle = this.attributes.original_title.value;
        this.innerHTML = `
            <a>[Propose changes ${OpenInNewModalSVG}]</a>
        `;
        this.#button = this.querySelector("a");

        this.#button.addEventListener("click", async (e) => {
            e.preventDefault();
            this.openDialog();
        }); 
    }

    openDialog () {
        const el = document.createElement("div");
        el.innerHTML = `
            <form id="propose-resource-form" method="dialog">
                <input type="text" required placeholder="Title" name="title" value="${this.#originalTitle}" />
                <textarea required placeholder="General reasoning. Why is this change necessary?" name="reasoning"></textarea>
                <button type="submit" value="confirm">Propose change</button>
            </form>
        `;

        const dialog = OpenDialog("Propose a change to this challenge", el.innerHTML);

        const handler = async (e) => { 
            dialog.removeEventListener("close", handler);
            if (e.target.returnValue !== "confirm") {
                return;
            }
            e.target.returnValue = "";
            const form = e.target.querySelector("form#propose-resource-form");

            const formData = new FormData(form);

            ShowProposalSubmitting();

            const response = await API.proposeChallengeChange(
                this.#originalTitle,
                formData.get("title"),
                formData.get("reasoning"),
            );

            if (response.ok) {
                ShowProposalSuccess();
            } else {
                const errorData = await response.json();
                OpenErrorDialog(errorData);
                return;
            }

            return false;
        };

        dialog.addEventListener("close", handler);
    }
}
